import Loading from 'components/Loading';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { downloadPdfWithAttachmentTypes } from 'services/TAPS_API';
import { downLoadTapsFileWithAttachType } from 'services/TAPS_ATTACH_API';
import { getFileType } from './utils';

const fileSaver = require('file-saver');

export default class DownloadTapsPdf extends Component {
  static propTypes = {
    pdf: PropTypes.string.isRequired,
    inn: PropTypes.number.isRequired,
    skipPrepare: PropTypes.bool,
    filename: PropTypes.string,
    attachmentId: PropTypes.string,
    attachmentType: PropTypes.string,
    notificationId: PropTypes.string,
  };

  static defaultProps = {
    skipPrepare: false,
    filename: null,
  };

  state = {
    error: false,
    loading: true,
  };
  started = false;

  componentDidMount() {
    this.startDownload();
  }

  componentDidUpdate() {
    if (this.started) {
      return;
    }
    this.startDownload();
  }

  getErrorMessage() {
    const { error, loading } = this.state;
    if (error) {
      return loading
        ? 'Документ формируется. Пожалуйста, подождите.'
        : 'Ошибка формирования документа.';
    }

    return 'Загрузка документа началась.';
  }

  startDownload() {
    const { pdf, inn, skipPrepare, filename, attachmentType, attachmentId, notificationId } =
      this.props;
    if (!inn || !pdf) {
      return;
    }

    this.started = true;

    this.prepareRequest(pdf, inn, skipPrepare)
      .then(() => {
        return downLoadTapsFileWithAttachType(
          pdf,
          inn,
          attachmentId,
          attachmentType,
          notificationId,
        );
      })
      .then((response) => {
        if (!response.isOk) {
          throw new Error(response.error);
        }

        const blob = new Blob([response.data], { type: getFileType(filename) });

        fileSaver.saveAs(blob, filename || pdf, true);
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        window.console.error(err);
        this.setState({
          error: true,
          loading: false,
        });
      });
  }

  async prepareRequest(pdf, inn, skipPrepare) {
    const { attachmentId, attachmentType, notificationId } = this.props;

    if (skipPrepare) {
      return null;
    }
    const response = await downloadPdfWithAttachmentTypes(
      pdf,
      inn,
      attachmentId,
      attachmentType,
      notificationId,
    );

    if (!response.isOk) {
      throw response.error;
    }

    return response.data;
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="page">
        <div className="page-title_block">
          <h2 style={{ textAlign: 'center' }}>{this.getErrorMessage()}</h2>
        </div>
        {loading ? <Loading /> : null}
      </div>
    );
  }
}
